import React from "react";
import CategoryFormContent from "./CategoryFormContent";
import { CategoryFormProvider } from "./context/CategoryFormContext";

type Props = {
  onSubmit: (data: any) => Promise<any>;
  categories: any;
  category?: any;
  setActiveCategory?: any;
  toggleOpenPopin: any;
};

const CategoryForm: React.FC<Props> = ({
  onSubmit,
  category,
  categories,
  toggleOpenPopin,
  setActiveCategory,
}) => {
  return (
    <CategoryFormProvider
      category={category}
      categories={categories}
      toggleOpenPopin={toggleOpenPopin}
      setActiveCategory={setActiveCategory}
    >
      <CategoryFormContent onSubmit={onSubmit} />
    </CategoryFormProvider>
  );
};

export default CategoryForm;
